import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundwave = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1112_4660)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.816599 5.56934C0.366325 5.56934 0 5.91851 0 6.34769V9.683C0 10.1122 0.366325 10.4614 0.816599 10.4614C1.26687 10.4614 1.6332 10.1122 1.6332 9.683V6.34769C1.6332 5.91851 1.26687 5.56934 0.816599 5.56934Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.40742 3.20872C3.95715 3.20872 3.59082 3.55789 3.59082 3.98707V12.0398C3.59082 12.469 3.95715 12.8182 4.40742 12.8182C4.85769 12.8182 5.22402 12.469 5.22402 12.0398V3.98344C5.22402 3.55425 4.85769 3.20508 4.40742 3.20508V3.20872Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00215 0.0117188C7.55187 0.0117188 7.18555 0.360889 7.18555 0.790078V15.2334C7.18555 15.6625 7.55187 16.0117 8.00215 16.0117C8.45242 16.0117 8.81875 15.6625 8.81875 15.2334V0.790078C8.81875 0.360889 8.45242 0.0117188 8.00215 0.0117188Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.593 3.20872C11.1427 3.20872 10.7764 3.55789 10.7764 3.98707V12.0398C10.7764 12.469 11.1427 12.8182 11.593 12.8182C12.0432 12.8182 12.4096 12.469 12.4096 12.0398V3.98344C12.4096 3.55425 12.0432 3.20508 11.593 3.20508V3.20872Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.1838 5.56934C14.7335 5.56934 14.3672 5.91851 14.3672 6.34769V9.683C14.3672 10.1122 14.7335 10.4614 15.1838 10.4614C15.6341 10.4614 16.0004 10.1122 16.0004 9.683V6.34769C16.0004 5.91851 15.6341 5.56934 15.1838 5.56934Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1112_4660",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(0 0.0117188)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSoundwave);
export default ForwardRef;
